import { h } from 'preact';
import Page from 'components/pages/page';
import Youtube from 'components/shared/youtube/youtube.js';
import Kaltura from 'components/shared/kaltura/kaltura.js';
import Playlist from 'components/shared/playlist/playlist.js';
import s from 'components/pages/videos/videos.sss';
import queryString from 'qs';
import { Link, goToPage } from 'components/core/link/link.js';
import { updateQueryStringItem } from 'utils/clientUtils';
import { sortObjectByOrder } from 'utils/utils';
import { getPlaylistData } from 'services/youtubeApi.js';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer';
import { SvgCarrotDown, SvgCarrotUp } from 'components/shared/svgIcons/svgIcons';
import { getCopy } from 'utils/copy';
import formatDateTime from 'utils/formatDateTime';
import { accessNested, joinClasses, parseDate } from 'utils/utils';
import { track } from 'utils/tracking';
const isServer = typeof window === 'undefined';
import Vimeo from 'components/shared/vimeo/vimeo.js';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class Videos extends Page {

	constructor(props) {
		super();
		let { showPlaylist, list, youtubePlaylistID, autoCollapse } = props.pageData || {};

		this.listRequestId = 0;
		this.state = {
			isOpen: showPlaylist, // are the thumnail videos shown
			playlist: [],
			showTitle: !props.pageData.disableVideoTitle,
			overlay: false, // end of playlist overlay
			countDown: 5 // countdown timer for end of plalist
		};
		this.autoCollapse = autoCollapse;

		// countdown timer function, gets called on playlist end
		this.countDownTimer = this.countDownTimer.bind(this);

		const dynamicList = this.getDynamicList(props);

		this.setupList(dynamicList || list, youtubePlaylistID, props);
	}

	componentDidMount(...args) {
		if (typeof super.componentDidMount === 'function') {
			super.componentDidMount(...args);
		}
		Store.emit('VIDEO_PLAYER_SHOW');
		window.addEventListener('popstate', this.checkQueryString);
	}

	componentWillUnmount(...args) {
		if (super.componentWillUnmount && typeof super.componentWillUnmount === 'function') {
			super.componentWillUnmount(...args);
		}
		Store.emit('VIDEO_PLAYER_HIDE');
		window.removeEventListener('popstate', this.checkQueryString);
	}

	checkQueryString = (detect, explicit) => {
		if (isServer) {
			return false;
		}
		let qs = queryString.parse(location.search.slice(1));
		if (explicit && !qs.v) {
			return false;
		}
		let vid = qs.v ? this.list.find(item => item.ytid === qs.v) || this.list[qs.v] : this.list[0];
		return detect === true ? vid : this.selectVideo(vid, true);
	};

	setupList(list, youtubePlaylistID) {
		if (!list) list = [];
		if (!Array.isArray(list)) {
			list = Object.keys(list).map(k => list[k]);
		}
		// Important ! Remove disabled elements
		let now = Date.now();
		list = list.filter(e => {
			if (!e) return false;
			if (e.from && e.from > now) return false;
			if (e.to && e.to < now) return false;
			return true;
		});

		if (youtubePlaylistID && youtubePlaylistID !== 'null') {
			// if legacy playlistId exists add it to the new list
			list.push({ playlistId: youtubePlaylistID });
		}

		let requestId = ++this.listRequestId;
		this.list = list;
		// Looping through objects to start looking for playlists in order to replace them
		let playlists = list.map(item => {
			if (!item.playlistId) {
				return;
			}
			// Do a call to get the data from youtube
			return getPlaylistData(item.playlistId).then(data => {
				if (requestId !== this.listRequestId) {
					return;
				}
				return this.replacePlaylistWithVideos(item.playlistId, data);
			}).catch(e => e);
		});

		return Promise.all(playlists).then(() => {
			// We requested a new setup before the end of the current one
			if (requestId !== this.listRequestId) return;
			this.setState({
				playlist: this.list
			});
			let newVid;
			if (this.state.activeItem) {
				newVid = this.list.find(vid => vid.ytid === this.state.activeItem.ytid);
			}
			newVid = newVid || this.checkQueryString(true, true) || this.list[0];
			this.selectVideo(newVid);
		});
	}

	getDynamicList(props) {
		let dyn = props.dynamicData;
		let useDynamicData = !__IS_DEMO__ && !__IS_LOCAL__;
		if (!dyn || !useDynamicData) return false;
		let upToDate = dyn.updateTime && dyn.updateTime > window.__BUILD_DATE__;
		return props.id === 'videos' && upToDate && dyn.videoList;
	}

	componentWillReceiveProps(props) {
		if (this.props.dynamicData !== props.dynamicData) {
			let dynList = this.getDynamicList(props);
			if (dynList) {
				this.setupList(dynList, props.pageData.youtubePlaylistID, props);
			}
		}
	}

	// finding index of playlist and replacing with actual videos
	replacePlaylistWithVideos(playlistId, data) {
		let playlistIndex;
		// looking for index of playlist in list and grabbing current playlist
		let activePlaylist = this.list.find((item, index) => {
			if (item.playlistId && item.playlistId === playlistId) {
				playlistIndex = index;
				return true;
			}
			return false;
		});
		// create list of useable videos from youtubeAPI
		let newList = data.items.filter(playlistItem => {
			// remove items that have been disabled by producer
			if (activePlaylist && activePlaylist.disabledItems && activePlaylist.disabledItems.indexOf(playlistItem.snippet.resourceId.videoId) !== -1) {
				return false;
			}
			// filter out videos with no thumbnail (typically these will be videos that have been deleted)
			return playlistItem.snippet.thumbnails;
		}).map((playlistItem, index) => ({
			name: playlistItem.snippet.title,
			thumbSrc: playlistItem.snippet.thumbnails.medium.url,
			ytid: playlistItem.snippet.resourceId.videoId,
			originalOrder: index
		}));
		if (activePlaylist && activePlaylist.playlistOrder) {
			let order = activePlaylist.playlistOrder;
			if (typeof order !== 'object') order = [order];
			if (!Array.isArray(order)) {
				order = Object.keys(order).sort((a, b) => a.localeCompare(b, 'en', { numeric: true })).map(k => order[k]);
			}
			newList.sort((item1, item2) => {
				// get index of video in playlistOrder
				let index1 = order.indexOf(item1.ytid);
				let index2 = order.indexOf(item2.ytid);

				// if order isn't prescribed, then let's add it to the back
				if (index1 === -1) {
					index1 = order.length + item1.originalOrder;
				}
				if (index2 === -1) {
					index2 = order.length + item2.originalOrder;
				}

				// compare order and sort
				return index1 - index2;
			});
		}
		// replace playlist with videos at correct index
		this.list = [
			...this.list.slice(0, playlistIndex),
			...newList,
			...this.list.slice(playlistIndex + 1)
		];
	}

	// TODO: add tracking here
	selectVideo(item, initial) {
		if (!item || item === this.state.activeItem) return false;
		if (initial === undefined) initial = !this.state.activeItem;
		this.setState({ activeItem: item });

		// change url so you can share with a specific video in mind
		if (!isServer && this.list.length > 1) {
			let vidIndex = this.state.playlist.indexOf(item);
			let qsVal = vidIndex === 0 ? null : item.ytid || vidIndex || null;
			let currentQs = queryString.parse(location.search.slice(1));
			if (qsVal != currentQs.v) {
				updateQueryStringItem('v', qsVal, {}, !initial);
			}
		}
		return true;
	}

	// if autoCollapse exists, close the thumbnails after 4 seconds of the video playing
	onPlay = () => {
		if (!this.props.pageData.disableVideoTitle) {
			clearTimeout(this.titleTimer);
			this.titleTimer = setTimeout(() => {
				this.setState({ showTitle: false });
			}, 1618);
		}

		if (this.autoCollapse) {
			clearTimeout(this.playTimer);
			this.playTimer = setTimeout(() => {
				this.setState({ isOpen: false });
			// }, 4000);
			}, 30000);
		}
	};

	// if autoCollapse exists, show the thumbnails when paused
	onPause = () => {
		if (!this.props.pageData.disableVideoTitle) {
			clearTimeout(this.titleTimer);
			this.setState({ showTitle: true });
		}
		if (this.autoCollapse) {
			this.stopCollapsing();
			this.setState({ isOpen: true });
		}
	};

	stopCollapsing() {
		clearTimeout(this.playTimer);
	}

	getSimpleVideoPlayerProps() {
		return {};
	}

	renderVideoPlayer() {
		let { pageData, client, sideNavActive } = this.props;
		let { muted } = pageData;
		let { activeItem, isOpen } = this.state;
		if (pageData.forceOpen) {
			isOpen = true;
		}

		if (!activeItem) {
			return;
		}

		// Adding this to be able to change it in overrides
		let autoplay = this.autoplay === undefined ? true : this.autoplay;

		if (activeItem.videoSrc) {
			// There is a source provided for the video,
			// lets use standard video player instead of youtube
			const videoName = (activeItem.name || 'video').replace(/ +/g, '-').toLowerCase();
			const captions = sortObjectByOrder(activeItem.captions);
			return (
				<SimpleVideoPlayer
					key={activeItem.videoSrc}
					src={activeItem.videoSrc}
					class={s.videoPlayer}
					parentClass={s.videoPlayerWrapper}
					autoplay={autoplay}
					showControls
					useTracking
					trackPrefix={videoName}
					onVideoEnded={this.goToNextItem}
					poster={activeItem.thumbSrc}
					captions={captions}
					aria-label={activeItem.ariaLabel}
					unmountResetVideoProgress
					{...this.getSimpleVideoPlayerProps()}
				/>
			);
		}
		if (activeItem.vimeoID) {
			return (
				<Vimeo
					vimeoID={activeItem.vimeoID}
					class={s.vimeoWrapper}
					useTracking
					autoplay
				/>
			);
		}

		if (activeItem && activeItem.disneySrc) {
			let length = this.props.pageData.list.filter(item => item !== null).length;
			return (
				<Kaltura
					src={activeItem.disneySrc}
					onVideoPage
					length={length}
					data={activeItem}
				/>
			);
		}

		let iframeClass = isOpen ? s.trailer : s.trailerFull;
		if (sideNavActive) {
			iframeClass = isOpen ? s.trailerSideNav : s.trailerSideNavFull;
		}
		let delay = pageData.delay;
		let videoTitle = activeItem.name;

		return (
			<Youtube
				appData={this.props.appData}
				passedTitle={videoTitle}
				showTitle={this.state.showTitle}
				activeItem={activeItem}
				maintainAspectRatio={client.deviceSize !== 'desktop'}
				onVideoEnded={this.goToNextItem}
				iframeClass={iframeClass}
				ref={ref => this.$video = ref}
				onPlay={this.onPlay}
				client={client}
				autoplay={autoplay}
				delay={delay}
				customDesktopUI={pageData.customDesktopUI}
				onPause={this.onPause}
				muted={muted}
			/>
		);
	}

	getExtraContent() {
		return;
	}


	// cancel button, close overlay, reset timers
	closeOverlay = () => {
		clearInterval(this.timer);
		clearTimeout(this.pageTimeout);
		this.setState({
			countDown: 5,
			overlay: !this.state.overlay,
			isOpen: true
		});
	};

	countDownTimer() {
		// Remove one second, set state so a re-render happens
		const countDown = Math.max(this.state.countDown - 1, 1);
		this.setState({ countDown });
		if (countDown === 1) {
			clearInterval(this.timer);
		}
	}

	renderOverlay() {
		if (!this.state.overlay) {
			return;
		}
		let props = this.props;
		let showtimes = props.showtimes || {};
		let copy = accessNested(props, 'appData.copy') || {};

		let pageData = props.pageData || {};
		let playlistRedirect = pageData.playlistRedirect !== 'undefined' ? pageData.playlistRedirect : {};
		let playlistRedirectContent;
		if (showtimes.status && playlistRedirect) {
			let playlistRedirectPage = playlistRedirect.pageId || 'showtimes';
			let playlistRedirectCopy = (playlistRedirect.copy || copy.$GET_TICKETS || 'Redirecting') + '...' + this.state.countDown;
			playlistRedirectContent = (
				<div>
					<Link pageId={playlistRedirectPage} linkClass={s.showtimesOverlayBtn} extraOnClick={this.closeOverlay}>
						{playlistRedirectCopy}
					</Link>
					<div onClick={this.closeOverlay} class={s.cancelBtn}>Cancel</div>
				</div>
			);
		}

		let overlayClasses = this.state.isOpen ? s.notFullscreen : s.fullscreen;
		return (
			<div class={joinClasses(s.overlay, overlayClasses)}>
				<div class={s.overlayContent}>
					<div class={s.overlayTitle}>{copy.$TITLE}</div>
					{playlistRedirectContent}
				</div>
			</div>
		);
	}

	render(props, state) {
		const {
			appData,
			activePage,
			pageData,
			sideNavActive,
			client,
			showtimes = {}
		} = props;

		let {
			playlist,
			isOpen,
			activeItem
		} = state;

		if (pageData.forceOpen) {
			isOpen = true;
		}

		// link in top right corner of page to link back to home
		let xLink;
		if (pageData.xLink) {
			let page = typeof pageData.xLink === 'string' ? pageData.xLink : 'home';
			xLink = (
				<Link linkClass={s.xLink} pageId={page}>
					<span class={s.xIcon} />
				</Link>
			);
		}

		let optionalText;
		if (pageData.optionalText) {
			let videoSEO = getCopy(pageData.optionalText, {
				RELEASE: formatDateTime(parseDate(appData.meta.dates.release), 'MMMM dd, yyyy')
			});
			optionalText = (<p class={s.videoSEO}>{videoSEO}</p>);
		}

		let playlistElem;
		if (playlist.length > 1) {
			let showtimesPage;
			if (!pageData.disableAutoRedirect) {
				showtimesPage = pageData.pageButton || (this.props.showtimes.status && 'showtimes');
			}

			let ToggleSvg = isOpen ? SvgCarrotDown : SvgCarrotUp;

			let toggle;
			if (!pageData.forceOpen) {
				toggle = (
					<div
						class={s.toggle}
						onClick={this.togglePlaylistCallback}
						tabindex="0"
						role="button"
						onKeyDown={this.togglePlaylistWithKeyboard}
					>
						<ToggleSvg class={s.fullScreenSvg} key={isOpen ? 'down' : 'up'} />
					</div>
				);
			}

			playlistElem = [
				toggle,
				<Playlist
					key="videosPlaylist"
					device={client.device}
					copy={appData.copy}
					list={playlist}
					onPlaylistItemClick={this.updateActive}
					isOpen={isOpen}
					playlistClass={joinClasses(s.playlist, isOpen ? s.openPlaylist : s.hiddenPlaylist)}
					showtimesPage={showtimesPage}
					activePage={activePage}
					activeItem={activeItem}
					showButtons
					playlistId="video"
				/>
			];
		}

		let tickets;
		const showTickets = this.state.showTitle ? s.active : s.inActive;
		tickets = (
			<Link
				pageId="showtimes"
				linkClass={joinClasses(s.showtimesBtn, showTickets)}
				extraOnClick={() => Store.emit(actions.VIDEOS_TICKET_CLICK)}
			>
				{this.props.appData.copy.$GET_TICKETS}
			</Link>
		);

		return (
			<div ref={ref => this.ytWrapper = ref} class={sideNavActive ? s.ytWrapperSideNav : s.ytWrapper}>
				{this.renderOverlay()}
				{optionalText}
				{xLink}
				{showtimes.status && !pageData.disableShowtimesCTA && tickets}
				{this.renderVideoPlayer()}
				{this.getExtraContent()}
				{playlistElem}
			</div>
		);
	}

	/**
	 *  CALLBACKS
	 */

	goToNextItem = (loop) => {
		clearTimeout(this.titleTimer);
		let current = this.state.playlist.indexOf(this.state.activeItem);
		let nextId = current + 1;
		// hard true check because the youtube player sends itself as the first arg
		if (loop === true) {
			nextId %= this.state.playlist.length;
		}
		let nextItem = this.state.playlist[nextId];

		if (nextItem) {
			return this.selectVideo(nextItem);
		}

		const {
			disableAutoRedirect,
			playlistRedirect = {}
		} = this.props.pageData;

		if (disableAutoRedirect) {
			return;
		}

		let pageId = playlistRedirect.pageId;
		if (!pageId) {
			pageId = accessNested(this.props, 'appData.pages.home') ? 'home' : 'showtimes';
		}

		if (!accessNested(this.props, 'showtimes.status')) {
			return goToPage(pageId);
		}

		this.setState({
			overlay: true
		});

		// clear timer out before setting to page load out
		// removes duplicate timer issues
		clearInterval(this.timer);
		this.timer = setInterval(this.countDownTimer, 1000);

		// clear timer out before setting to page load out
		// removes duplicate timer issues
		clearTimeout(this.pageTimeout);
		this.pageTimeout = setTimeout(() => goToPage(pageId), 5000);

		let exitFn = [
			'exitFullscreen',
			'msExitFullscreen',
			'webkitCancelFullScreen',
			'mozCancelFullScreen'
		].find(name => typeof document[name] === 'function');
		if (exitFn) {
			// Try/catch as it can cause "document not active error"
			// (ideally we would check if the doc has a fullscreenElement before exiting)
			try {
				document[exitFn]();
			} catch (e) {}
		}
	};

	goToPrevItem = (loop) => {
		let current = this.state.playlist.indexOf(this.state.activeItem);
		if (current === -1) current = 0;
		let prevId = current - 1;
		if (loop === true) {
			let len = this.state.playlist.length;
			// + len to ensure a positive result
			prevId = (prevId + len) % len;
		}
		let prevItem = this.state.playlist[prevId];

		if (prevItem) {
			this.selectVideo(prevItem);
		}
	};

	togglePlaylistCallback = (e) => {
		if (e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}
		this.stopCollapsing();
		this.autoCollapse = false;

		let isOpen = !this.state.isOpen;
		track({ a: 'video-thumbnails-bar-' + (isOpen ? 'open' : 'closed') });
		this.setState({ isOpen });
	};

	togglePlaylistWithKeyboard = (e) => {
		if (e.key === 'Enter') {
			this.togglePlaylistCallback(e);
		}
	};

	updateActive = (item, e) => {
		if (e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}
		this.selectVideo(item);
	};

	getContentOutside() {
		return;
	}

}

export const dependencies = {
	showtimes   : true,
	videos      : true,
	dynamicData : true,
	misc        : true
};
